const initialState = {
  response: {
    error: null
}
};
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "ERROR":
      return {
        ...state,
        error: action.payload
      };
      case "DISMISS_ERROR":
        return {
          ...state,
          error: null
        };      
    default:
      return state;
  }
};